import { Contrast } from "../../../types/general.types";
import { NumberBadgeVariants } from "./constants";
import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
const { text, color } = ids || {};
const neutral = css `
  background: ${color.action.neutral.ids_color_action_neutral_variant};
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const neutralDark = css `
  background: ${color.contrast.ids_color_contrast_onDark};
  color: ${color.action.neutral.ids_color_action_neutral_base};
`;
const primary = css `
  background: ${color.action.primary.ids_color_action_primary_base};
  color: ${color.action.primary.ids_color_action_primary_contrast};
`;
const primaryDark = css `
  background: ${color.action.primary.ids_color_action_primary_contrast};
  color: ${color.action.primary.ids_color_action_primary_base};
`;
const secondary = css `
  background: ${color.action.secondary.ids_color_action_secondary_base};
  color: ${color.action.secondary.ids_color_action_secondary_contrast};
`;
const secondaryDark = css `
  background: ${color.action.secondary.ids_color_action_secondary_contrast};
  color: ${color.action.secondary.ids_color_action_secondary_base};
`;
const error = css `
  background: ${color.feedbacks.ids_color_feedback_alert};
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const getBadgeKindStyle = (variant, contrast) => {
    switch (variant) {
        case NumberBadgeVariants.neutral:
            return contrast === Contrast.dark ? neutralDark : neutral;
        case NumberBadgeVariants.primary:
            return contrast === Contrast.dark ? primaryDark : primary;
        case NumberBadgeVariants.secondary:
            return contrast === Contrast.dark ? secondaryDark : secondary;
        case NumberBadgeVariants.error:
            return error;
        default:
            return contrast === Contrast.dark ? neutralDark : neutral;
    }
};
export const StyledNumberBadge = styled.div `
  ${({ isMobile }) => isMobile
    ? { ...text.label.ids_textStyle_label_small_bold }
    : { ...text.label.ids_textStyle_label_large_bold }};
  line-height: ${({ isMobile }) => (isMobile ? "1.3" : "1")};
  ${({ variant, contrast }) => getBadgeKindStyle(variant, contrast)}
  border: 0px none;
  border-radius: ${ids.size.general.ids_size_general_80x};
  display: inline-block;
  min-width: ${({ isMobile }) => isMobile
    ? ids.size.general.ids_size_general_20x
    : ids.size.general.ids_size_general_24x};
  height: ${({ isMobile }) => isMobile
    ? ids.size.general.ids_size_general_20x
    : ids.size.general.ids_size_general_24x};
  padding: 0 ${ids.size.general.ids_size_general_6x};
  text-align: center;
`;
//# sourceMappingURL=NumberBadge.style.js.map